export function calculateAge(birthDate) {
  if (!birthDate) {
    return birthDate;
  }

  const birth = new Date(birthDate);
  const today = new Date();

  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  const dayDiff = today.getDate() - birth.getDate();

  // Adjust age if birth date hasn't occurred yet this year
  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--;
  }

  return age;
}

export const getAge = (dob) => {
  const birthDate = new Date(dob);
  const today = new Date();
  const age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  return m < 0 || (m === 0 && today.getDate() < birthDate.getDate())
    ? age - 1
    : age;
};

export const selectStyles = {
  control: (provided) => ({
    ...provided,
    backgroundColor: "#F4F4F4",
    borderRadius: "8px",
    border: "1px solid #e2e8f0",
    minHeight: "44px",
    boxShadow: "none",
    cursor: "pointer",
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#ffffff",
    border: "1px solid #d6c1a8",
    borderRadius: "999px",
    padding: "2px 6px",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "#4b5563",
    fontSize: "0.85rem",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#a16207",
    cursor: "pointer",
    ":hover": {
      backgroundColor: "#fde68a",
      color: "#78350f",
    },
  }),
};

export const customStyles = {
  control: (base) => ({
    ...base,
    width: "100%",
    padding: "2px 2px", // react-select already has internal padding
    fontSize: "15px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    boxSizing: "border-box",
    background: "#f4f4f4",
    outline: "none",
    minHeight: "40px", // close to native <select>
    boxShadow: "none",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 8px",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "0 8px",
  }),
  menu: (base) => ({
    ...base,
    borderRadius: "6px",
    marginTop: 2,
  }),
};

export const customStylesbusiness = {
  control: (base) => ({
    ...base,
    width: "100%",
    fontSize: "14px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    background: "#f4f4f4",
    minHeight: "41px",
    height: "41px",
    boxShadow: "none",
  }),

  valueContainer: (base) => ({
    ...base,
    display: "flex",
    flexWrap: "nowrap", // ✅ STOP wrapping
    overflowX: "auto", // ✅ Horizontal scroll
    scrollbarWidth: "thin",
    whiteSpace: "nowrap",
    height: "41px",
    alignItems: "center",
  }),

  multiValue: (base) => ({
    ...base,
    flexShrink: 0, // ✅ Prevent shrinking
    backgroundColor: "#f1f5f9",
  }),

  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
    minWidth: 60,
  }),

  indicatorsContainer: (base) => ({
    ...base,
    height: "41px",
  }),

  dropdownIndicator: (base) => ({
    ...base,
    padding: "0 8px",
  }),

  menu: (base) => ({
    ...base,
    borderRadius: "6px",
    marginTop: 2,
  }),

  option: (base) => ({
    ...base,
    backgroundColor: "white",
    color: "#333",
    ":hover": {
      backgroundColor: "#f3f4f6",
    },
  }),

  menuList: (base) => ({
    ...base,
    padding: 0,
  }),

  multiValueLabel: (base) => ({
    ...base,
    color: "#333",
  }),

  multiValueRemove: (base) => ({
    ...base,
    ":hover": {
      backgroundColor: "#e5e7eb",
      color: "#111",
    },
  }),
};


export const getDefaultProfileIcon = (user) => {
   
  return user?.Gender === 1
    ? require("../assests/images/MaleDefaultIcon.png")
    : require("../assests/images/FeMaleDefaultIcon.png");
};


export const RatingStars = ({ rating = 0 }) => {
  const numericRating = Number(rating);

  if (numericRating <= 0) return null;

  const roundedRating = Math.round(numericRating);

  return (
    <div className="review-stars">
      {"★".repeat(roundedRating)}
      {"☆".repeat(5 - roundedRating)}
       
    </div>
  );
};